const banners_es = require('./banners.json')
export default banners_es